import { useRef, useState } from 'react';
import { PartnerOrganization } from 'vopay';
import { api } from '@/services/api.config';

/**
 * The partner's whole organization in one call — the root, every partner, account and sub-account in
 * its book, and the book's totals — for the Organization Overview chart (ID-13859). Not paginated:
 * the chart is drawn from the whole book at once.
 */
export default function useFetchPartnerOrganization() {
  const [fetchingOrganization, setFetchingOrganization] = useState(false);
  const [organization, setOrganization] = useState<PartnerOrganization>();
  // Only the newest request may set the book: a reload (an entity was created) can answer before
  // the load it overlaps, and the older answer would then put the created entity back out of sight.
  const request = useRef(0);

  async function fetchPartnerOrganization() {
    request.current += 1;
    const thisRequest = request.current;

    try {
      setFetchingOrganization(true);
      const res = await api.fetchPartnerOrganization();

      if (!res.Success) {
        throw new Error(res.ErrorMessage);
      }

      if (thisRequest === request.current) {
        setOrganization({ Organization: res.Organization, Entities: res.Entities, Totals: res.Totals });
      }

      return res;
    } catch (error) {
      console.error(error);
      throw error;
    } finally {
      setFetchingOrganization(false);
    }
  }

  return { fetchingOrganization, organization, fetchPartnerOrganization };
}
